import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cpLogoImg from '../assets/cp-logo.png';
import emitter from '../util/emitter';

class CpLogo extends Component {
  render() {
    return (
      <div className="cp-logo" onClick={() => {
        emitter.emit('goHome');
        this.props.history.push('/basic/index');
      }}>
        <img src={cpLogoImg} alt="" />
      </div>
    );
  }
}

export default withRouter(CpLogo);